import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import {
  Table,
  Modal,
  Button,
  Card,
  Row,
  Layout,
  List,
  Tooltip,
  Avatar,
  Divider,
  Select,
  Input,
  Badge,
} from 'antd';
import moment from 'moment';
import {
  editAlias,
  deleteAlias,
  createAlias,
  getAliases,
} from '../aliases/alias_action';
import {
  getActivity,
  getUserKeyWordFilter,
  getTopKeywords,
  updateUserKeyWordFilter,
} from '../wiki_action';
import {
  UserOutlined,
  InfoCircleOutlined,
  FileAddOutlined,
  FilterOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import queryString from 'query-string';
import {
  XAxis,
  Tooltip as ReTooltip,
  AreaChart,
  Area,
  ResponsiveContainer,
} from 'recharts';
import BookEmoji from './BookEmoji';
import { Col, Typography, message } from 'antd';
import Highcharts from 'highcharts';
import wordCloud from 'highcharts/modules/wordcloud.js';
import HighchartsReact from 'highcharts-react-official';
import TopKeyWords from './confluenceTopKeyword';
import { getChannelList } from '../../../../components/skills/skills_action';

Highcharts.setOptions(
  localStorage.getItem('theme') === 'dark'
    ? {
        chart: {
          backgroundColor: '#141414',
        },
      }
    : {}
);

wordCloud(Highcharts);
const { Title, Text } = Typography;
const { Content } = Layout;
const { Search } = Input;
class ConfluecneAnalytics extends React.Component {
  initial_search_channel = {
    key: 'all_channels',
    value: 'all_channels',
    label: 'All Channels',
  };
  initial_filter_states = {
    search_text: '',
    search_range: '30days',
    search_feedback_type: 'all',
    search_match_type: 'both',
    search_channel: this.initial_search_channel,
  };
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '0',
      adoptionData: [],
      usageData: [],
      topKeyWords: [],
      channelsWithKeyword: [],
      channelsWithActivity: [],
      activity: [],
      total: 0,
      tLoading: true,
      currentActivity: {},
      modalType: '',
      activityLogRecord: null,
      loading: false,
      showBookEmojiModal: false,
      pageSize: 10,
      negativeKeywords: [],
      filterDataLoading: true,
      ...this.initial_filter_states,
    };
  }

  handleModeChange = (e) => {
    const mode = e.target.value;
    this.setState({ mode });
  };
  componentDidMount() {
    // console.log("noobView",this.props.skillView)
    const isTokenisThere =
      this.props.currentSkill &&
      this.props.currentSkill.metadata &&
      this.props.currentSkill &&
      this.props.currentSkill.metadata.token_obj &&
      this.props.currentSkill.metadata.token_obj.userToken;
    if (
      this.props.currentSkill &&
      this.props.currentSkill.metadata &&
      !isTokenisThere
    ) {
      message.error('Token is not added.');
      this.props.history.push(
        `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=connection`
      );
    }

    const parsedQueryString = queryString.parse(window.location.search);
    this.setState({ activeTab: parsedQueryString.sView });

    this.setState({ loading: true });
    // axios.get("/bot/api/" + this.props.match.params.wId + "/wiki/getActivityPerDayPerUser")
    axios
      .get(
        '/bot/api/w/' +
          this.props.match.params.wId +
          '/wiki/getActivityPerDayPerUser'
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ loading: false });
          this.setState({ adoptionData: res.data.data });
        }
      });

    // axios.get("/bot/api/" + this.props.match.params.wId + "/wiki/getActivityPerDay")
    axios
      .get(
        '/bot/api/w/' + this.props.match.params.wId + '/wiki/getActivityPerDay'
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success) {
          this.setState({ usageData: res.data.data });
        }
      });

    // if (this.props.workspace && this.props.workspace.is_enterprise) {
    getTopKeywords({ wId: this.props.match.params.wId }).then((res) => {
      if (res.data.success && res.data.topKeyWords) {
        this.setState({
          topKeyWords: res.data.topKeyWords,
          channelsWithKeyword: res.data.channelsWithKeyword,
        });
      }
    });
    // } else if (
    //   parsedQueryString.view_page &&
    //   parsedQueryString.view_page === 'keyword'
    // )
    //   this.props.history.push(
    //     `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=analytics`
    //   );

    // axios.get("/bot/api/w/" + this.props.match.params.wId + "/wiki/activity?page=1").then((res) => {
    getActivity({ wId: this.props.match.params.wId, page: 1 }).then((res) => {
      this.setState({ tLoading: false });
      if (res.data.success) {
        this.setState({
          activity: res.data.activity,
          total: res.data.total,
          channelsWithActivity: res.data.channelsWithActivity,
        });
      }
    });

    if (this.props.channels.length === 0) {
      this.props.getChannelList(this.props.match.params.wId);
    }
    // if(sView=="usage"){

    // }else if(sView="logs"){

    // }else{

    // }
    // this.setOption()

    this.getViewData(parsedQueryString.sView);

    if (this.props.botUser && this.props.botUser._id)
      this.getUserKeywordFilterData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      const parsedQueryString = queryString.parse(window.location.search);
      if (parsedQueryString && parsedQueryString.search_text)
        this.setState(
          {
            ...this.initial_filter_states,
            search_text: parsedQueryString.search_text,
          },
          () => this.onFilter()
        );
    }

    if (this.props.botUser !== prevProps.botUser && this.props.botUser._id)
      this.getUserKeywordFilterData();
  }

  getUserKeywordFilterData = () => {
    this.setState({ filterDataLoading: true });
    getUserKeyWordFilter({
      wId: this.props.match.params.wId,
      user_id: this.props.botUser._id,
    }).then((res) => {
      if (res && res.data && res.data.success)
        this.setState({
          negativeKeywords: res.data.filterData
            ? res.data.filterData.negativeKeywords || []
            : [],
          filterDataLoading: false,
        });
    });
  };

  getViewData = (view) => {
    if (view == 'logs') {
      this.setState({ tLoading: true });
      // axios.get("/bot/api/w/" + this.props.match.params.wId + "/wiki/activity?page=1").then((res) => {
      getActivity({ wId: this.props.match.params.wId, page: 1 }).then((res) => {
        this.setState({ tLoading: false });
        if (res.data.success) {
          this.setState({
            activity: res.data.activity,
            total: res.data.total,
            channelsWithActivity: res.data.channelsWithActivity,
          });
        }
      });
    } else if (view == 'usage') {
      this.setState({ loading: true });
      // axios.get("/bot/api/" + this.props.match.params.wId + "/wiki/getActivityPerDay")
      axios
        .get(
          '/bot/api/w/' +
            this.props.match.params.wId +
            '/wiki/getActivityPerDay'
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success) {
            this.setState({ usageData: res.data.data });
          }
        });
    } else {
      this.setState({ loading: true });
      axios
        .get(
          '/bot/api/w/' +
            this.props.match.params.wId +
            '/wiki/getActivityPerDayPerUser'
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({ loading: false });
            this.setState({ adoptionData: res.data.data });
          }
        });
    }
  };

  onFilter = (pagination) => {
    const {
      search_channel,
      search_text,
      search_range,
      search_feedback_type,
      search_match_type,
    } = this.state;
    this.setState({ tLoading: true });
    // let url = `/bot/api/w/${this.props.match.params.wId}/wiki/activity?page=${pagination && pagination.current ? pagination.current : '1'}`
    // if(search_text) url += `&search_text=${search_text}`
    // if(search_range && search_range !== '30days') url += `&search_range=${search_range}`
    // if(search_feedback_type && search_feedback_type !== 'all') url += `&search_feedback_type=${search_feedback_type}`
    // if(search_match_type && search_match_type !== 'both') url += `&search_match_type=${search_match_type}`
    // if(search_channel && search_channel.key && search_channel.key !== 'all_channels') url += `&search_channel=${search_channel.key}`
    // axios.get(url).then((res) => {
    //   if (res.data.success) {
    //     this.setState({ activity: res.data.activity, total: res.data.total, tLoading: false });
    //   }
    // });

    getActivity({
      wId: this.props.match.params.wId,
      search_text,
      search_range,
      search_feedback_type,
      search_match_type,
      search_channel,
      page: pagination && pagination.current ? pagination.current : 1,
    }).then((res) => {
      if (res.data.success) {
        this.setState({
          activity: res.data.activity,
          total: res.data.total,
          tLoading: false,
          channelsWithActivity: res.data.channelsWithActivity,
        });
      }
    });
  };

  openModal = (modalType, activity) => {
    this.setState({ visible: true, modalType, currentActivity: activity });
  };

  handleCancel = () => {
    this.setState({ currentActivity: {}, modalType: '', visible: false });
  };

  goToConfluence = (url) => {
    window.open(url, '_blank');
  };

  setOption(sView) {
    // this.setState({ view: view, id: id, name: name });
    let queryStringObject = queryString.stringify({
      view: 'analytics',
      sView: sView,
    });
    let path = window.location.pathname;

    const obj = {
      title: 'analytics',
      url: path + `?view=analytics&sView=${sView}`,
    };
    window.history.pushState(obj, obj.title, obj.url);
    this.getViewData(sView);
  }

  getQueryName = (name) => {
    let text = name;
    if (name.length > 25) {
      text = text.substring(0, 25).trim();
      return (
        <Tooltip title={name}>
          <span> {text + '...'}</span>
        </Tooltip>
      );
    }
    return text;
  };

  _getInitials(string) {
    return string
      .trim()
      .split(' ')
      .map(function (item) {
        if (item.trim() != '') {
          return item[0].toUpperCase();
        } else {
          return;
        }
      })
      .join('')
      .slice(0, 2);
  }
  getModalHeader = () => {
    const { modalType } = this.state;
    return modalType === 'confluecneDoc' ? (
      <>
        {this.getQueryName(this.state.currentActivity.msg.text)}{' '}
        <span>
          {' (' +
            this.state.currentActivity.confluenceData.length +
            '  doc found)'}
        </span>
      </>
    ) : modalType === 'helpful' ? (
      this.state.currentActivity.likes.length + ' people found helpful'
    ) : (
      this.state.currentActivity.dislikes.length + ' people found not helpful'
    );
  };

  addToUpdateConfluence = (record) => {
    this.setState({ showBookEmojiModal: true, activityLogRecord: record });
  };

  truncateString = (input, len) => {
    if (input.length > len) {
      let truncatedString = input.slice(0, len - 3);
      let str = truncatedString + '...';
      return str;
    } else {
      return input;
    }
  };

  getChannels = () => {
    const { channels } = this.props;
    const { channelsWithActivity } = this.state;
    let validChannelList = [];
    channelsWithActivity.forEach((activityChannel) => {
      if (activityChannel.channelId) {
        const channel = channels.find(
          (c) => c.id === activityChannel.channelId
        );
        if (channel)
          validChannelList.push({
            value: channel.id,
            key: channel.id,
            label: channel.name,
          });
        else if (this.props.isWorkspaceAdimin)
          validChannelList.push({
            value: activityChannel.channelId,
            key: activityChannel.channelId,
            label: activityChannel.channelId,
          });
      }
    });
    return validChannelList;
  };

  userNegativeKeywordModal = () => {
    const { topKeyWords, negativeKeywords } = this.state;
    const wId = this.props.match.params.wId;
    const botuser_id = this.props.botUser._id;
    // const { skills } = this.props;
    // const wikiSkill = skills && skills.find((skill) => skill.key === 'wiki');

    let tempNegativeKeywords = [...this.state.negativeKeywords];

    const onChange = (value) => {
      tempNegativeKeywords = value;
    };

    const onOk = () => {
      updateUserKeyWordFilter({
        wId,
        data: { negativeKeywords: tempNegativeKeywords },
        user_id: botuser_id,
      }).then((res) => {
        if (res && res.data && res.data.success)
          this.setState({
            negativeKeywords: res.data.filterData.negativeKeywords,
          });
      });
    };

    Modal.confirm({
      title: 'Word Cloud Filters',
      width: 500,
      icon: <SettingOutlined />,
      content: (
        <>
          <div style={{ marginBottom: 16 }}>
            <Title level={5}>Exclusions</Title>
            <Text type='secondary'>Type keyword(s) to exclude from report</Text>
            <div style={{ marginBottom: 16 }}>
              <Select
                mode='multiple'
                allowClear
                style={{
                  width: '100%',
                }}
                placeholder='Select keyword to exclude from report'
                defaultValue={negativeKeywords}
                onChange={(value) => {
                  onChange(value);
                }}
                options={
                  topKeyWords
                    ? topKeyWords.map((keywordData) => {
                        return {
                          key: keywordData.keyWord,
                          value: keywordData.keyWord,
                          label: keywordData.keyWord,
                        };
                      })
                    : []
                }
              />
            </div>
          </div>
        </>
      ),
      okText: 'Save Filter',
      onOk() {
        onOk();
      },
    });
  };

  render() {
    const { mode, search_channel } = this.state;
    const { channels, workspace, skills } = this.props;
    // const wikiSkill = skills && skills.find((skill) => skill.key === 'wiki')
    const parsedQueryString = queryString.parse(window.location.search);
    const table_columns = [
      {
        title: 'Request message',
        dataIndex: 'query_text',
        key: 'message',

        render: (text, record) => {
          if (!text && record.msg && record.msg.text) {
            text = record.msg.text;
          }
          return text ? this.getQueryName(text) : <></>;
        },
      },
      //   ...this.getColumnSearchProps("name"),

      {
        title: 'Doc Found',
        dataIndex: 'confluenceData',
        key: 'confluenceData',
        render: (text, record) => {
          return (
            <a onClick={() => this.openModal('confluecneDoc', record)}>
              {text ? text.length + ' doc(s)' : '0 doc(s)'}{' '}
            </a>
          );
        },
      },
      //   ...this.getColumnSearchProps('alias')},

      // {
      //   title:"Status",
      //    dataIndex:"enabled",
      //     key:"enabled" ,
      //     showSorterTooltip:false,

      //   sorter: (a, b) => (a.enabled ? 'Enabled' : 'Not Enabled').length - (b.enabled ? 'Enabled' : 'Not Enabled').length,

      //   render: (text, record) => {

      //     return  text? <Tag color="green">Enabled</Tag>:<Tag color="red">Disabled</Tag>
      //   }
      // },
      {
        title: 'Requestor',
        dataIndex: 'activity_by',
        key: 'activity_by',

        render: (text, record) => {
          return text ? (
            <>{text.displayName || text.name} </>
          ) : (
            <>Unknown User</>
          );
        },

        //  ...this.getColumnSearchProps("created_by")
      },
      {
        title: 'Channel Name',
        key: 'channel',

        dataIndex: 'channel',
        render: (text, record) => {
          // console.log(text)

          return text ? <>{text.name || text.id || ''} </> : <></>;
          // console.log(record)
        },
      },

      {
        title: 'Activity At',
        dataIndex: 'activity_at',
        key: 'activity_at',
        sorter: (a, b) => {
          let d1 = new Date(a.activity_at).getTime();
          let d2 = new Date(b.activity_at).getTime();

          if (d1 < d2) {
            return -1;
          }
          if (d1 > d2) {
            return 1;
          }
          return 0;
        },
        defaultSortOrder: 'descend',
        showSorterTooltip: false,
        render: (text) => {
          return moment(new Date(text)).format('Do MMM, h:mm a');
        },
      },
      {
        title: 'Helpful',
        dataIndex: 'likes',
        key: 'likes',

        render: (text, record) => {
          return (
            <a onClick={() => this.openModal('helpful', record)}>
              {text && text.length > 0 ? (
                <Avatar.Group
                  maxCount={2}
                  size='small'
                  maxStyle={{
                    color: '#f56a00',
                    backgroundColor: '#fde3cf',
                  }}
                >
                  {text.map((item) => (
                    <Tooltip
                      title={
                        item
                          ? item.displayName || item.name || item.user_name
                          : 'Unknown User'
                      }
                      placement='top'
                    >
                      {item ? (
                        item.profilePicUrl ? (
                          <Avatar src={item.profilePicUrl} />
                        ) : (
                          <Avatar>
                            {' '}
                            {this._getInitials(
                              item.displayName || item.name || item.user_name
                            )}
                          </Avatar>
                        )
                      ) : (
                        <Avatar icon={<UserOutlined />} />
                      )}{' '}
                    </Tooltip>
                  ))}
                </Avatar.Group>
              ) : (
                0
              )}{' '}
            </a>
          );
        },

        //  ...this.getColumnSearchProps("created_by")
      },

      {
        title: 'Not Helpful',
        dataIndex: 'dislikes',
        key: 'dislikes',

        render: (text, record) => {
          return (
            <a onClick={() => this.openModal('not_helpful', record)}>
              {text && text.length > 0 ? (
                <Avatar.Group
                  maxCount={2}
                  size='small'
                  maxStyle={{
                    color: '#f56a00',
                    backgroundColor: '#fde3cf',
                  }}
                >
                  {text.map((item) => (
                    <Tooltip
                      title={
                        item
                          ? item.displayName || item.name || item.user_name
                          : 'Unknown User'
                      }
                      placement='top'
                    >
                      {item ? (
                        item.profilePicUrl ? (
                          <Avatar src={item.profilePicUrl} />
                        ) : (
                          <Avatar>
                            {' '}
                            {this._getInitials(
                              item.displayName || item.name || item.user_name
                            )}
                          </Avatar>
                        )
                      ) : (
                        <Avatar icon={<UserOutlined />} />
                      )}{' '}
                    </Tooltip>
                  ))}
                </Avatar.Group>
              ) : (
                0
              )}{' '}
            </a>
          );
        },

        //  ...this.getColumnSearchProps("created_by")

        //  ...this.getColumnSearchProps("created_by")
      },
      {
        title: 'Action',
        render: (text, record, index) => (
          <>
            <Tooltip title='Add or update Confluence page'>
              <Button
                onClick={() => this.addToUpdateConfluence(record)}
                icon={<FileAddOutlined />}
              />
            </Tooltip>
          </>
        ),
      },
    ];

    // const optionsData = this.state.topKeyWords.map((data) => {
    //   return { name: data.keyWord, weight: data.count };
    // });

    let optionsData = [];
    this.state.topKeyWords.forEach((data) => {
      if (!this.state.negativeKeywords.includes(data.keyWord))
        optionsData.push({ name: data.keyWord, weight: data.count });
    });

    let options = {
      series: [
        {
          type: 'wordcloud',
          data: optionsData,
          name: 'Occurrences',
        },
      ],
      title: {
        text: '',
      },
      subtitle: {
        text: '',
      },
      tooltip: {
        headerFormat:
          '<span style="font-size: 16px"><b>{point.key}</b></span><br>',
      },
      credits: {
        enabled: false,
      },
    };

    //   {
    //     "_id" : ObjectId("61384450757c5058ee3efe85"),
    //     "confluenceData" : [
    //         {
    //             "url" : "https://stagetrooprnov.atlassian.net/wiki/spaces/TEST/pages/16449590/lables+used+in+this+for+tr+lvl+dv+but+keyword+not+used+anywhere",
    //             "title" : "lables used in this for tr lvl dv but keyword not used anywhere",
    //             "id" : "16449590"
    //         }
    //     ],
    //     "msg" : {
    //         "text" : "development",
    //         "ts" : "1631077454.001600"
    //     },
    //     "team_id" : ObjectId("60b7139660cb173b7b4d3ae2"),
    //     "workspace_id" : ObjectId("60b713974e6cc132ba0a991e"),
    //     "activity_by" : ObjectId("60b7139860cb173b7b4d3ae9"),
    //     "activity_at" : ISODate("2021-09-08T05:04:16.181Z"),
    //     "__v" : 1
    // }

    return (
      <Content
        style={{
          overflow: 'scroll',
          overflowX: 'hidden',
          marginLeft: 0,
          marginBottom: 50,
        }}
      >
        {parsedQueryString && parsedQueryString.view_page === 'activity_log' ? (
          <>
            <Row
              gutter={[16, 16]}
              justify='space-between'
              align='bottom'
              style={{ padding: 36 }}
            >
              <Col
                xs={{ span: 20 }}
                sm={{ span: 24 }}
                lg={{ span: 24 }}
                xxl={{ span: 24 }}
              >
                <>
                  <Button
                    onClick={() => {
                      this.props.history.push(
                        `/${this.props.match.params.wId}/skills/${
                          this.props.match.params.skill_id
                        }?view=analytics${
                          parsedQueryString && parsedQueryString.search_text
                            ? '&view_page=keyword'
                            : ''
                        }`
                      );
                    }}
                  >
                    Go back
                  </Button>
                  <Divider />
                  <div>
                    <Search
                      style={{ width: 200, marginRight: 8 }}
                      onSearch={(value) => {
                        this.setState({ search_text: value }, () =>
                          this.onFilter()
                        );
                      }}
                      autoFocus
                      onChange={(e) =>
                        this.setState({ search_text: e.target.value })
                      }
                      value={this.state.search_text}
                    />
                    <Select
                      style={{
                        width: 150,
                        marginRight: 8,
                      }}
                      value={search_channel.key}
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(value, data) => {
                        this.setState(
                          {
                            search_channel: value
                              ? data
                              : this.initial_search_channel,
                          },
                          () => this.onFilter()
                        );
                      }}
                      loading={channels.length === 0}
                      options={[
                        this.initial_search_channel,
                        ...this.getChannels(),
                      ]}
                    />
                    <Select
                      style={{
                        width: 150,
                        marginRight: 8,
                      }}
                      value={this.state.search_range}
                      onChange={(value, data) => {
                        this.setState({ search_range: value }, () =>
                          this.onFilter()
                        );
                      }}
                      options={[
                        {
                          value: 'day',
                          label: 'Past day',
                        },
                        {
                          value: '7days',
                          label: 'Past 7 days',
                        },
                        {
                          value: '30days',
                          label: 'Past 30 days',
                        },
                        {
                          value: '90days',
                          label: 'Past 90 days',
                        },
                        {
                          value: 'year',
                          label: 'Past year',
                        },
                      ]}
                    />
                    <Select
                      style={{
                        width: 150,
                        marginRight: 8,
                      }}
                      value={this.state.search_feedback_type}
                      onChange={(value, data) => {
                        this.setState({ search_feedback_type: value }, () =>
                          this.onFilter()
                        );
                      }}
                      options={[
                        {
                          value: 'all',
                          label: 'All feedback',
                        },
                        // {
                        //   value: 'none',
                        //   label: 'No feedback',
                        // },
                        {
                          value: 'helpful',
                          label: 'Helpful',
                        },
                        {
                          value: 'not_helpful',
                          label: 'Not helpful',
                        },
                      ]}
                    />
                    <Select
                      value={this.state.search_match_type}
                      onChange={(value, data) => {
                        this.setState({ search_match_type: value }, () =>
                          this.onFilter()
                        );
                      }}
                      style={{
                        width: 150,
                        marginRight: 8,
                      }}
                      options={[
                        {
                          value: 'both',
                          label: 'Both',
                        },
                        {
                          value: 'found',
                          label: 'Match found',
                        },
                        {
                          value: 'notfound',
                          label: 'Match not found',
                        },
                      ]}
                    />
                    <Button
                      type='link'
                      onClick={() => {
                        this.setState({ ...this.initial_filter_states }, () =>
                          this.onFilter()
                        );
                      }}
                    >
                      Reset Filters
                    </Button>
                  </div>
                  <Divider />
                  <Table
                    title={() => (
                      <Tooltip
                        placement='bottomLeft'
                        title='Showing all Confluence search activity details'
                      >
                        <Title level={5}>
                          Activity Log
                          <InfoCircleOutlined style={{ paddingLeft: 8 }} />
                        </Title>
                      </Tooltip>
                    )}
                    loading={this.state.tLoading}
                    pagination={{
                      pageSize: 10,
                      total: this.state.total || 10,
                      showTotal: (total) => `Total ${total} activities`,
                      showSizeChanger: false,
                      hideOnSinglePage: true,
                    }}
                    columns={table_columns}
                    onChange={this.onFilter}
                    dataSource={this.state.activity}
                    // style={{ margin: 16 }}
                  />
                  {this.state.visible && (
                    <Modal
                      title={this.getModalHeader()}
                      visible={this.state.visible}
                      footer={null}
                      onCancel={this.handleCancel}
                    >
                      <List
                        itemLayout='horizontal'
                        dataSource={
                          this.state.modalType === 'confluecneDoc'
                            ? this.state.currentActivity.confluenceData
                            : this.state.modalType === 'helpful'
                            ? this.state.currentActivity.likes
                            : this.state.currentActivity.dislikes
                        }
                        renderItem={(item, index) => (
                          <List.Item key={item ? item._id || item.id : index}>
                            {/* <List.Item.Meta */}

                            {
                              this.state.modalType === 'confluecneDoc' ? (
                                <h4>
                                  {index + 1 + ': '}
                                  <a
                                    style={{ color: '#402E96' }}
                                    onClick={() =>
                                      this.goToConfluence(item.url)
                                    }
                                  >
                                    {item.title}
                                  </a>
                                </h4>
                              ) : (
                                <div>
                                  {' '}
                                  <>
                                    {item ? (
                                      item.profilePicUrl ? (
                                        <Avatar src={item.profilePicUrl} />
                                      ) : (
                                        <Avatar>
                                          {' '}
                                          {this._getInitials(
                                            item.displayName ||
                                              item.name ||
                                              item.user_name
                                          )}
                                        </Avatar>
                                      )
                                    ) : (
                                      <Avatar icon={<UserOutlined />} />
                                    )}{' '}
                                  </>
                                  <span
                                    style={{
                                      marginRight: 4,
                                      lineHeight: '24px',
                                    }}
                                  >
                                    {' '}
                                    {item
                                      ? item.displayName ||
                                        item.name ||
                                        item.user_name
                                      : 'Unknwon User'}{' '}
                                  </span>
                                </div>
                              )

                              // <List.Item.Meta
                              //   avatar={item.profilePicUrl?<Avatar src={item.profilePicUrl} />: <Avatar icon={<UserOutlined />} />}
                              //   title={item.displayName||item.name||item.user_name}
                              //   description={item.email}

                              // />
                            }

                            {/* /> */}
                          </List.Item>
                        )}
                      />
                    </Modal>
                  )}
                </>
              </Col>
            </Row>
          </>
        ) : parsedQueryString && parsedQueryString.view_page === 'keyword' ? (
          <TopKeyWords
            topKeyWords={this.state.topKeyWords}
            channelsWithKeyword={this.state.channelsWithKeyword}
          />
        ) : (
          <Row
            gutter={[16, 16]}
            justify='space-between'
            align='bottom'
            style={{ padding: 36 }}
          >
            <Col
              xs={{ span: 20 }}
              sm={{ span: 24 }}
              // lg={{ span: workspace.is_enterprise ? 12 : 24 }}
              // xxl={{ span: workspace.is_enterprise ? 12 : 24 }}
              lg={{ span: 12 }}
              xxl={{ span: 12 }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Card
                  style={{ width: '100%', height: 235 }}
                  bodyStyle={{ height: '100%' }}
                  size='small'
                  loading={this.state.loading}
                  extra={
                    <Button
                      onClick={() => {
                        this.setState({ ...this.initial_filter_states }, () =>
                          this.onFilter()
                        );
                        this.props.history.push(
                          `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=analytics&view_page=activity_log`
                        );
                      }}
                      loading={this.state.loading}
                    >
                      Show Logs
                    </Button>
                  }
                  title={
                    <Tooltip
                      placement='bottomLeft'
                      title='Showing number of Confluence activities (articles served,
          clicked, voted, searched etc) in past 90 days'
                    >
                      <Title level={5}>
                        Usage Report
                        <InfoCircleOutlined style={{ paddingLeft: 8 }} />
                      </Title>
                    </Tooltip>
                  }
                >
                  <ResponsiveContainer width='100%' height='90%'>
                    <AreaChart data={this.state.usageData}>
                      <ReTooltip
                        contentStyle={
                          localStorage.getItem('theme') === 'dark' && {
                            backgroundColor: '#000',
                          }
                        }
                      />
                      <XAxis dataKey={'date'} />
                      <Area
                        type='monotone'
                        dataKey='activities'
                        fill={
                          localStorage.getItem('theme') === 'default'
                            ? '#402E96'
                            : '#664af0'
                        }
                        // strokeWidth={2}
                        // fillOpacity={1}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </Card>
                <Card
                  style={{ width: '100%', height: 235 }}
                  bodyStyle={{ height: '100%', padding: 12 }}
                  size='small'
                  title={
                    <Tooltip
                      placement='bottomLeft'
                      title='Showing number of active users in past 90 days'
                    >
                      <Title level={5}>
                        Adoption Report
                        <InfoCircleOutlined style={{ paddingLeft: 8 }} />
                      </Title>
                    </Tooltip>
                  }
                  loading={this.state.loading}
                >
                  <ResponsiveContainer width='100%' height='90%'>
                    <AreaChart data={this.state.adoptionData}>
                      <ReTooltip
                        contentStyle={
                          localStorage.getItem('theme') === 'dark' && {
                            backgroundColor: '#000',
                          }
                        }
                      />
                      <XAxis dataKey={'date'} />
                      <Area
                        type='monotone'
                        dataKey='users'
                        fill={
                          localStorage.getItem('theme') === 'default'
                            ? '#402E96'
                            : '#664af0'
                        }
                        // strokeWidth={2}
                        // fillOpacity={1}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </Card>
              </div>
            </Col>
            <Col
              xs={{ span: 20 }}
              sm={{ span: 24 }}
              lg={{ span: 12 }}
              xxl={{ span: 12 }}
            >
              {/* {workspace && workspace.is_enterprise && ( */}
              <Card
                style={{ height: 470 }}
                bodyStyle={{ height: '100%' }}
                size='small'
                // title='Top Keywords (Past 30 days)'
                title={
                  <>
                    <Text>Top Keywords (Past 30 days)</Text>
                    <Button
                      style={{ marginRight: 4, marginLeft: 8 }}
                      onClick={() => this.userNegativeKeywordModal()}
                      // icon={<FilterOutlined />}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 4,
                        }}
                      >
                        <FilterOutlined />
                        {this.state.negativeKeywords.length > 0 && (
                          <Badge
                            count={this.state.negativeKeywords.length}
                            style={{ background: '#faad14' }}
                          />
                        )}
                      </div>
                    </Button>
                  </>
                }
                extra={
                  <Button
                    onClick={() =>
                      this.props.history.push(
                        `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=analytics&view_page=keyword`
                      )
                    }
                  >
                    Show All
                  </Button>
                }
                loading={this.state.loading || this.state.filterDataLoading}
              >
                <HighchartsReact highcharts={Highcharts} options={options} />
              </Card>
              {/* )} */}
            </Col>
          </Row>
        )}

        {this.state.showBookEmojiModal && (
          <BookEmoji
            handleClose={() => this.setState({ showBookEmojiModal: false })}
            record={this.state.activityLogRecord}
          />
        )}
      </Content>
    );
  }
}

const mapStateToProps = (state) => ({
  aliases: state.confluecne.aliases,

  currentSkill: state.skills.currentSkill,
  channels: state.skills.channels,
  workspace: state.common_reducer.workspace,
  isWorkspaceAdimin: state.common_reducer.isAdmin,
  skills: state.skills.skills,
  botUser: state.common_reducer.tpuser,
});

export default withRouter(
  connect(mapStateToProps, {
    editAlias,
    deleteAlias,
    createAlias,
    getAliases,
    getChannelList,
  })(ConfluecneAnalytics)
);
